// @flow

import React, { Fragment, useContext } from 'react';

import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
import ReactAppContext from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { t } from 'Src/i18n';

type Props = {|
  title: string,
  proposal: Proposal,
|};

export const AlternativePriceTitle = ({ title, proposal: { price } }: Props) => {
  const appContext = useContext(ReactAppContext);

  if (!price) {
    return null;
  }

  return (
    <div className="flex alternative-price-title-container">
      {(isSeller(appContext) && price.gap >= 30) || price.gap < 30 ? (
        <div className="flex">
          <Icon
            className="alternative-price-title-icon alternative-price-title-icon--full"
            color={COLORS.BLUE}
            name={ICONS.LIGHTBULB}
            width="6rem"
            hasRtl
          />
          <span className="alternative-price-title ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6 text-blue">
            {title}
          </span>
        </div>
      ) : (
        <Fragment>
          <div className="inline-flex items-center alternative-price-title-call-center-advise">
            <Icon
              className="alternative-price-title-icon"
              color={COLORS.BLUE}
              name={ICONS.LIGHTBULB}
              width="4rem"
              hasRtl
            />
            <span className="alternative-price-title ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6 text-blue">
              {t('booking.counterProposalPopIn.callCenterAdvise')}
            </span>
          </div>
          <div className="flex alternative-price-title-please-call items-center">
            <Icon
              className="alternative-price-title-icon"
              color={COLORS.BLUE}
              name={ICONS.PHONE_BUBBLE}
              width="4rem"
              hasRtl
            />
            <div className="ml-4">
              <span className="inline-block w-full text-blue text-lg">
                {t('booking.counterProposalPopIn.pleaseCallLabel')}
              </span>
              <span className="text-emerald font-bold text-lg">
                {t('travelAdvisor.phoneNumber')}
              </span>
              <span className="text-gray text-md alternative-price-title-call-cost">
                {' '}
                {t('booking.counterProposalPopIn.callCost')}
              </span>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};
